module.exports = __webpack_public_path__ + "static/environmental-stewardship-mobile.1fb26465.webp";